const divider = {
    styleOverrides: {
        root: {
            /*borderColor: rgba(colors.action.light, 0.15),
            '&:before': {
                borderTop: `${borderWidth[1]} solid ${colors.divider}`,
            },
            '&:after': {
                borderTop: `${borderWidth[1]} solid ${colors.divider}`,
            },*/
        },
    },
};

export default divider;
